import { lazy } from 'react';
import { PermissionsGuard } from './components';
import {
    AD_CAMPAIGN_AUTH,
    CREATE_PERMISSION,
    READ_PERMISSION,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';

export const Routes = [
    {
        exact: true,
        path: '/create/adCampaign',
        guard: PermissionsGuard,
        roles: {
            permission: AD_CAMPAIGN_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(
            () => import('src/views/adCampaign/AdCampaignCreateView')
        ),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: AD_CAMPAIGN_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/adCampaigns/:id',
        component: lazy(
            () => import('src/views/adCampaign/AdCampaignDetailsView')
        ),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: AD_CAMPAIGN_AUTH,
            crud: UPDATE_PERMISSION,
        },
        path: '/management/adCampaigns/:id/edit',
        component: lazy(
            () => import('src/views/adCampaign/AdCampaignEditView')
        ),
    },

    {
        exact: true,
        path: '/management/adCampaigns',
        guard: PermissionsGuard,
        roles: {
            permission: AD_CAMPAIGN_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () => import('src/views/adCampaign/AdCampaignListView')
        ),
    },
];
